import React from "react";
import { Form, Icon, InputNumber, Popover, DatePicker, TimePicker } from "antd";
import moment from "moment";
import "./Monetization.css";

const Monetization = ({
  form,
  disabled,
  disabledKp1urc,
  monetizationSectionPass
}) => {
  const { getFieldDecorator } = form;
  // const popoverS1 = (
  //   <div className="popover-content">
  //     <p>
  //       Срок оплаты фактического использования ТС при отклонении от маршрута или
  //       в случае превы-шения расчётного времени использования ТС в связи с
  //       действиями организатора или пассажи-ров, компенсации дополнительных
  //       платежей, компенсации в случае одностороннего отказа от договора, дней,
  //       возврата фрахтовщиком ранее уплаченной в счёт оказания услуг суммы в
  //       случае отказа от договора в ходе оказания услуг. (С1)
  //     </p>
  //   </div>
  // );
  const popoverSH1 = (
    <div className="popover-content">
      <p>
        Размер штрафа, уплачиваемого фрахтовщиком фрахтователю за
        непредоставление транспортного средства (либо предоставление
        транспортного средства ненадлежащего качества), либо в случае
        необеспечения фрахтовщиком наличия необходимых документов, либо
        выявившиеся в ходе движения по маршруту нарушения правил перевозки
        пассажиров, % от цены договора (Ш1)
      </p>
    </div>
  );
  const popoverSH2 = (
    <div className="popover-content">
      <p>
        Срок опоздания - продолжительность времени, по истечении которого неявка
        заказчика (всех пассажиров) на место посадки или непредоставление
        необходимых для осуществления перевозки документов или неявка
        фрахтователя (всех пассажиров) на посадку в промежуточном пункте для
        продолжения перевозки заказчик считается просрочившим, создавшим
        невозможность исполнения фрахтовщиком своего обязательства, мин. (Ш2)
      </p>
    </div>
  );
  const popoverSH3 = (
    <div className="popover-content">
      <p>
        Размер согласованных и заранее оценённых убытков, возмещаемых
        фрахтователем фрахтовщику в связи с неправомерным отказом фрахтователя
        от пользования предоставленным транспортным средством, либо в связи с
        необоснованным отказом фрахтователя оплачивать дополнительные платежи,
        либо при неоплате цены договора в соответствии с согласованным порядком,
        в случае невозможности исполнения фрахтовщиком своих обязанностей
        вследствие неявки фрахтователя (всех пассажиров) на посадку либо явки
        без необходимых для осуществления перевозки документов, % от цены
        договора (Ш3)
      </p>
    </div>
  );
  return !monetizationSectionPass ? (
    <div className="monetization-field">
      <div className="monetization-field__col4">
        {/*<div className="monetization-field__item2">
          <span className="label" />
          <span className="label label1">
            Срок оплаты фактического использования
            <br />
            ТС при отклонении от маршрута (С1), дней:
          </span>
          <Form.Item>
            {getFieldDecorator('s1')(
              <InputNumber
                style={{ width: 128 }}
                disabled={disabled}
                placeholder="12"
              />
            )}
          </Form.Item>
          <span className="extra-label">
            <span className="show-map">
              <Popover
                overlayClassName="order-popover"
                placement="topLeft"
                content={popoverS1}
                trigger="click"
              >
                <Icon type="question-circle" />
              </Popover>
            </span>
          </span>
        </div>*/}
        <div className="monetization-field__item2">
          <span className="label label1">
            Тариф за 1 мин. задержки при посадке сверх
            <br />
            расчётного времени, руб./мин:
          </span>
          <Form.Item>
            {getFieldDecorator("t2", {
              rules: [
                {
                  required: true,
                  message: "Поле, обязательное для заполнения"
                }
              ]
            })(
              <InputNumber
                style={{ width: 128 }}
                disabled={disabled}
                placeholder="12"
              />
            )}
          </Form.Item>
        </div>
        <div className="monetization-field__item2">
          <span className="label label1">
            Тариф за 1 мин. задержки отправления из промежуточного <br />
            пункта по вине фрахтователя (при превышении длительности <br />
            плановой остановки в промежуточном пункте) (Т4), руб./ мин.:
          </span>
          <Form.Item>
            {getFieldDecorator("t4", {
              rules: [
                {
                  required: true,
                  message: "Поле, обязательное для заполнения"
                }
              ]
            })(
              <InputNumber
                style={{ width: 128 }}
                disabled={disabled}
                placeholder="12"
              />
            )}
          </Form.Item>
        </div>
        <div className="monetization-field__item2">
          <span className="label label1">
            Тариф за 1 мин. задержки высадки в <br /> конечном пункте (Т6),
            руб./мин:
          </span>
          <Form.Item>
            {getFieldDecorator("t6", {
              rules: [
                {
                  required: true,
                  message: "Поле, обязательное для заполнения"
                }
              ]
            })(
              <InputNumber
                style={{ width: 128 }}
                disabled={disabled}
                placeholder="12"
              />
            )}
          </Form.Item>
        </div>
        <div className="monetization-field__item2">
          <span className="label label1">
            Стоимость минуты использования ТС при отклонении <br />
            от маршрута или внеплановой остановки по просьбе <br />
            фрахтователя/пассажира (Т7), руб. мин:{" "}
          </span>
          <Form.Item>
            {getFieldDecorator("t7", {
              rules: [
                {
                  required: true,
                  message: "Поле, обязательное для заполнения"
                }
              ]
            })(
              <InputNumber
                style={{ width: 128 }}
                disabled={disabled}
                placeholder="12"
              />
            )}
          </Form.Item>
        </div>
        <div className="monetization-field__item2">
          <span className="label label1">
            Стоимость километра пробега ТС за пределами МКАД <br />
            при отклонении от маршрута (Т8), руб./км:
          </span>
          <Form.Item>
            {getFieldDecorator("t8", {
              rules: [
                {
                  required: true,
                  message: "Поле, обязательное для заполнения"
                }
              ]
            })(
              <InputNumber
                style={{ width: 128 }}
                disabled={disabled}
                placeholder="12"
              />
            )}
          </Form.Item>
        </div>
        <div className="monetization-field__item2">
          <span className="label label1">
            Стоимость километра пробега ТС внутри МКАД <br />
            при отклонении от маршрута (Т9), руб./км:
          </span>
          <Form.Item>
            {getFieldDecorator("t9", {
              rules: [
                {
                  required: true,
                  message: "Поле, обязательное для заполнения"
                }
              ]
            })(
              <InputNumber
                style={{ width: 128 }}
                disabled={disabled}
                placeholder="12"
              />
            )}
          </Form.Item>
        </div>
        <div className="monetization-field__item2 double-margin">
          <span className="label label1">
            Размер штрафа, уплачиваемого фрахтовщиком <br />
            фрахтователю (Ш1), % от цены договора
          </span>
          <Form.Item>
            {getFieldDecorator("sh1", {
              rules: [
                {
                  required: true,
                  message: "Поле, обязательное для заполнения"
                }
              ]
            })(
              <InputNumber
                style={{ width: 128 }}
                disabled={disabled}
                placeholder="12"
              />
            )}
          </Form.Item>
          <span className="extra-label">
            <span className="show-map">
              <Popover
                overlayClassName="order-popover"
                placement="topLeft"
                content={popoverSH1}
                trigger="click"
              >
                <Icon type="question-circle" />
              </Popover>
            </span>
          </span>
        </div>
        <div className="monetization-field__item2">
          <span className="label label1">Срок опоздания (Ш2) ,мин:</span>
          <Form.Item>
            {getFieldDecorator("sh2", {
              rules: [
                {
                  required: true,
                  message: "Поле, обязательное для заполнения"
                }
              ]
            })(
              <InputNumber
                style={{ width: 128 }}
                disabled={disabled}
                placeholder="12"
              />
            )}
          </Form.Item>
          <span className="extra-label">
            <span className="show-map">
              <Popover
                overlayClassName="order-popover"
                placement="topLeft"
                content={popoverSH2}
                trigger="click"
              >
                <Icon type="question-circle" />
              </Popover>
            </span>
          </span>
        </div>
        <div className="monetization-field__item2">
          <span className="label label1">
            Размер согласованных и заранее оценённых убытков, <br />
            возмещ. фрахтователем фрахтовщику (Ш3), % от цены договора:
          </span>
          <Form.Item>
            {getFieldDecorator("sh3", {
              rules: [
                {
                  required: true,
                  message: "Поле, обязательное для заполнения"
                }
              ]
            })(
              <InputNumber
                style={{ width: 128 }}
                disabled={disabled}
                placeholder="12"
              />
            )}
          </Form.Item>
          <span className="extra-label">
            <span className="show-map">
              <Popover
                overlayClassName="order-popover"
                placement="topLeft"
                content={popoverSH3}
                trigger="click"
              >
                <Icon type="question-circle" />
              </Popover>
            </span>
          </span>
        </div>
      </div>

      <div className="monetization-field__item2">
        <span
          className="label"
          style={{ whiteSpace: "break-spaces", width: "218px" }}
        >
          Срок оплаты компенсации в сл. одностор. отказа (КП1):
        </span>
        <Form.Item>
          {getFieldDecorator("kp1urc", {
            rules: [
              {
                required: true,
                message: "Поле, обязательное для заполнения"
              }
            ],
            initialValue: form.getFieldValue("arrivalDatetime")
          })(
            <DatePicker
              style={{ width: 224 }}
              format="DD.MM.YYYY"
              placeholder="ДД.ММ.ГГГГ"
              disabled={disabledKp1urc}
              disabledDate={current =>
                current <= form.getFieldValue("arrivalDatetime")
              }
            />
          )}
        </Form.Item>
        <Form.Item>
          {getFieldDecorator("kp1urc", {
            rules: [
              {
                required: true,
                message: "Поле, обязательное для заполнения"
              }
            ],
            initialValue: form.getFieldValue("arrivalDatetime")
          })(
            <TimePicker
              style={{ width: 128 }}
              defaultOpenValue={moment("00:00", "HH:mm")}
              placeholder="Время"
              format="HH:mm"
              disabled={disabledKp1urc}
              disabledTime={() => {}}
            />
          )}
        </Form.Item>
      </div>

      <div
        className="monetization-field__lebel-line"
        style={{ maxWidth: "500px", marginBottom: "16px" }}
      >
        Размер компенсации фрахтовщику за односторонний отказ фрахтователя от
        договора в период менее чем за:
      </div>
      <div className="monetization-field__col4">
        <div className="monetization-field__item2">
          <span className="label">
            Часов до времени подачи, <br /> свыше..., час:
          </span>
          <Form.Item>
            {getFieldDecorator("kp1t")(
              <InputNumber
                style={{ width: 128 }}
                disabled={disabled}
                placeholder="Укажите"
              />
            )}
          </Form.Item>
          <div style={{ display: "inline-flex" }}>
            <span className="label" style={{ minWidth: "202px" }}>
              % от договора
            </span>
            <Form.Item>
              {getFieldDecorator("kp1p")(
                <InputNumber
                  style={{ width: 128 }}
                  disabled={disabled}
                  placeholder="Укажите"
                />
              )}
            </Form.Item>
          </div>
        </div>

        <div className="monetization-field__item2">
          <span className="label">
            Часов до времени подачи,
            <br /> менее, чем за..., час:
          </span>
          <Form.Item>
            {getFieldDecorator("kp2t")(
              <InputNumber
                style={{ width: 128 }}
                disabled={disabled}
                placeholder="Укажите"
              />
            )}
          </Form.Item>
          <div style={{ display: "inline-flex" }}>
            <span className="label" style={{ minWidth: "202px" }}>
              % от договора
            </span>
            <Form.Item>
              {getFieldDecorator("kp2p")(
                <InputNumber
                  style={{ width: 128 }}
                  disabled={disabled}
                  placeholder="Укажите"
                />
              )}
            </Form.Item>
          </div>
        </div>

        <div className="monetization-field__item2">
          <span className="label">
            Часов до времени подачи,
            <br /> менее, чем за..., час:
          </span>
          <Form.Item>
            {getFieldDecorator("kp3t")(
              <InputNumber
                style={{ width: 128 }}
                disabled={disabled}
                placeholder="Укажите"
              />
            )}
          </Form.Item>
          <div style={{ display: "inline-flex" }}>
            <span className="label" style={{ minWidth: "202px" }}>
              % от договора
            </span>
            <Form.Item>
              {getFieldDecorator("kp3p")(
                <InputNumber
                  style={{ width: 128 }}
                  disabled={disabled}
                  placeholder="Укажите"
                />
              )}
            </Form.Item>
          </div>
        </div>

        <div className="monetization-field__item2">
          <span className="label">
            Часов до времени подачи,
            <br /> менее, чем за..., час:
          </span>
          <Form.Item>
            {getFieldDecorator("kp4t")(
              <InputNumber
                style={{ width: 128 }}
                disabled={disabled}
                placeholder="Укажите"
              />
            )}
          </Form.Item>
          <div style={{ display: "inline-flex" }}>
            <span className="label" style={{ minWidth: "202px" }}>
              % от договора
            </span>
            <Form.Item>
              {getFieldDecorator("kp4p")(
                <InputNumber
                  style={{ width: 128 }}
                  disabled={disabled}
                  placeholder="Укажите"
                />
              )}
            </Form.Item>
          </div>
        </div>
      </div>

      <div
        className="monetization-field__lebel-line"
        style={{ maxWidth: "500px", marginBottom: "16px" }}
      >
        Размер компенсации фрахтователю за односторонний отказ фрахтовщика от
        договора в период менее чем за:
      </div>

      <div className="monetization-field__col4">
        <div className="monetization-field__item2">
          <span className="label">
            Часов до времени подачи,
            <br /> свыше..., час:
          </span>
          <Form.Item>
            {getFieldDecorator("kz1t")(
              <InputNumber
                style={{ width: 128 }}
                disabled={disabled}
                placeholder="Укажите"
              />
            )}
          </Form.Item>
          <div style={{ display: "inline-flex" }}>
            <span className="label" style={{ minWidth: "202px" }}>
              % от договора
            </span>
            <Form.Item>
              {getFieldDecorator("kz1p")(
                <InputNumber
                  style={{ width: 128 }}
                  disabled={disabled}
                  placeholder="Укажите"
                />
              )}
            </Form.Item>
          </div>
        </div>

        <div className="monetization-field__item2">
          <span className="label">
            Часов до времени подачи,
            <br /> менее, чем за..., час:
          </span>
          <Form.Item>
            {getFieldDecorator("kz2t")(
              <InputNumber
                style={{ width: 128 }}
                disabled={disabled}
                placeholder="Укажите"
              />
            )}
          </Form.Item>
          <div style={{ display: "inline-flex" }}>
            <span className="label" style={{ minWidth: "202px" }}>
              % от договора
            </span>
            <Form.Item>
              {getFieldDecorator("kz2p")(
                <InputNumber
                  style={{ width: 128 }}
                  disabled={disabled}
                  placeholder="Укажите"
                />
              )}
            </Form.Item>
          </div>
        </div>

        <div className="monetization-field__item2">
          <span className="label">
            Часов до времени подачи,
            <br /> менее, чем за..., час:
          </span>
          <Form.Item>
            {getFieldDecorator("kz3t")(
              <InputNumber
                style={{ width: 128 }}
                disabled={disabled}
                placeholder="Укажите"
              />
            )}
          </Form.Item>
          <div style={{ display: "inline-flex" }}>
            <span className="label" style={{ minWidth: "202px" }}>
              % от договора
            </span>
            <Form.Item>
              {getFieldDecorator("kz3p")(
                <InputNumber
                  style={{ width: 128 }}
                  disabled={disabled}
                  placeholder="Укажите"
                />
              )}
            </Form.Item>
          </div>
        </div>

        <div className="monetization-field__item2">
          <span className="label">
            Часов до времени подачи,
            <br /> менее, чем за..., час:
          </span>
          <Form.Item>
            {getFieldDecorator("kz4t")(
              <InputNumber
                style={{ width: 128 }}
                disabled={disabled}
                placeholder="Укажите"
              />
            )}
          </Form.Item>
          <div style={{ display: "inline-flex" }}>
            <span className="label" style={{ minWidth: "202px" }}>
              % от договора
            </span>
            <Form.Item>
              {getFieldDecorator("kz4p")(
                <InputNumber
                  style={{ width: 128 }}
                  disabled={disabled}
                  placeholder="Укажите"
                />
              )}
            </Form.Item>
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

export default Monetization;
